import $ from "jquery";
import {GPContextTexture} from "./gp-context-texture.js";
import {activePickerSnippet, activePickerItem, GPContextItems} from "./gp-context-items.js";
import {GPContextLabels} from "./gp-context-labels.js";
import {GPContextFixedCutter} from "./gp-context-fixedcutter.js";
import {GPContextInpainting} from "./gp-context-inpainting.js";
import {GPContextCloner} from "./gp-context-cloner.js";
import "konva";
import {GPLabel} from "./gp-label.js";
import {get} from "svelte/store";
import {
    selectedItemSet,
    showLabels,
    mode
} from "./gp.js";
import {GPPlant} from "./gp-plant";

export let GPProjectView = {
    stage: null,
    backgroundLayer: null,
    background: null, //This is an KonvaImage within backgroundLayer
    textureLayer: null, //This is a konva layer with an image drawn by user
    texture: null, //This is an KonvaImage within textureLayer with a final pattern. Its source data is from GP.project.textureCanvas
    plantLayer: null,
    cloner: null,
    width: null,
    height: null,
    sceneScale: 1,
    reflection: false,
    selectionRect: null,


    init: function () {
        GPProjectView.width = $('#GPProjectView').innerWidth();
        GPProjectView.height = $('#GPProjectView').innerHeight();

        if (GPProjectView.stage) {
            GPProjectView.backgroundLayer = null;
            GPProjectView.textureLayer = null;
            GPProjectView.plantLayer = null;

            GPProjectView.stage.destroyChildren();
            GPProjectView.stage.destroy();
        }
        GPProjectView.stage = new Konva.Stage({
            container: 'GPProjectView',
            width: GP.project.sizeX,
            height: GP.project.sizeY
        });

        GPProjectView.backgroundLayer = new Konva.Layer();
        GPProjectView.textureLayer = new Konva.Layer();
        GPProjectView.plantLayer = new Konva.Layer();

        // add the layer to the stage
        GPProjectView.stage.add(GPProjectView.backgroundLayer);
        GPProjectView.stage.add(GPProjectView.textureLayer);
        GPProjectView.stage.add(GPProjectView.plantLayer);

        GPProjectView.selectionRect = new Konva.Rect({
            stroke: "#00000050",
            fill: "#00000020",
            strokeWidth: 1,
        });
          // add the shape to the layer
        GPProjectView.plantLayer.add(GPProjectView.selectionRect);

        GPProjectView.createTextureImage();

        GPContextTexture.init(GPProjectView.textureLayer);
        GPContextItems.init(GPProjectView.plantLayer);
        GPContextLabels.init(GPProjectView.plantLayer);
        GPContextFixedCutter.init(GPProjectView);
        GPContextInpainting.init(GPProjectView);
        GPContextCloner.init(GPProjectView.backgroundLayer);

        $(window).off('resize', GPProjectView.onresize);
        $(window).on('resize', GPProjectView.onresize);
        $(window).off('orientationchange', GPProjectView.onresize);
        $(window).on('orientationchange', GPProjectView.onresize);
        $(".konvajs-content").off('mouseenter').on("mouseenter", function() {GPProjectView.setCursor()});
        $(".konvajs-content").off('mouseleave').on("mouseleave", function() {GPProjectView.setCursor("standard")});
        $(document).off("keydown", GPProjectView.handleKeyboard).on("keydown", GPProjectView.handleKeyboard);

        $(".GPProjectView").off('focusin').on("focusin", function(){$('.GPProjectView').addClass("active")});
        $(".GPProjectView").off('focusout').on("focusout", function(){$('.GPProjectView').removeClass("active")});

        $(".GPDesignPane").off("dragover").on("dragover", function(e){
            e.preventDefault();
            e.stopPropagation();
        });

        showLabels.subscribe(GPProjectView.updateLabelsVisibility);
        let funcSurfLoaded = () => {GPProjectView.stage.draw()};
        $(document).off("GPSurfaceLoaded", funcSurfLoaded).on("GPSurfaceLoaded", funcSurfLoaded);
        let funcBGLoaded = () => {GPProjectView.stage.draw()};
        $(document).off("GPBackgroundLoaded", funcBGLoaded).on("GPBackgroundLoaded", funcBGLoaded);
    },

    initNew: function () {
        return new Promise(function(resolve, reject) {
            GPProjectView.init();
            GPProjectView.setBackground().then(resolve);
        });
    },

    initFromProject: function () {
        return new Promise(function(resolve, reject) {
            GPProjectView.init();

            Promise.all(GP.project.items.map(function(el) {
                if (el instanceof GPLabel)
                    GPContextLabels.addLabelToView(el);
                else
                    GPContextItems.addItemInstanceToView(el);
            })).then(GPProjectView.setBackground).then(resolve);
        });
    },

    createTextureImage: function() {
        GPProjectView.texture = new Konva.Image({
            x: 0,
            y: 0,
            id: "texture",
            image: GP.project.textureCanvas
        });
        GPProjectView.textureLayer.add(GPProjectView.texture);

        GPProjectView.texture.width(GPProjectView.width);
        GPProjectView.texture.height(GPProjectView.height);
    },


    getItemImgData: function (itemInstance) {
        var id = itemInstance.id;
        var image = GPProjectView.stage.find('#' + id)[0];
        return image;
    },   


    setBackground: function () {
        return new Promise(function(resolve, reject) {
            GP.showWaiting();
            GP.project.getBackgroundCanvas().then(function(canvas) {
                if (GPProjectView.background)
                    GPProjectView.background.remove();

                GPProjectView.sceneScale = GPProjectView.width / GP.project.sizeX;
                GPProjectView.background = new Konva.Image({
                    x: 0,
                    y: 0,
                    id: "background",
                    image: canvas,
                    width: GPProjectView.width,
                    height: GPProjectView.width * canvas.height / canvas.width
                });
                GPProjectView.backgroundLayer.add(GPProjectView.background);
                GPProjectView.background.setZIndex(0);
                GPProjectView.onresize();

                GP.clearWaiting();
                $(document).trigger('GPBackgroundLoaded' );
                resolve();
            })
        })
    },

    coordsViewToProject: function (x, y) {
        return {
            x: x / GPProjectView.sceneScale,
            y: y / GPProjectView.sceneScale
        };
    },

    coordsProjectToView: function (x, y) {
        return {
            x: x * GPProjectView.sceneScale,
            y: y * GPProjectView.sceneScale
        };
    },

    coordsViewToImagePos: function (projx, projy, viewx, viewy, imagew, imageh, itemInstance) {
        var scale = itemInstance.itemImageScale(projy) * GPProjectView.sceneScale * GP.project.sizeX / 1024;
        return {
            x: viewx - imagew * scale / 2,
            y: viewy - imageh * scale,
            scale: scale
        }
    },

    onresize: function () {
        var mw = $('.GPDesignViewport').width() * GP.viewZoom;
        var mh = $('.GPDesignViewport').height() * GP.viewZoom;
        var sw = mw / GP.project.sizeX;
        var sh = mh / GP.project.sizeY;
        
        GPProjectView.sceneScale = Math.min(sw,sh);

        $('#GPProjectView').innerWidth(GP.project.sizeX * GPProjectView.sceneScale);
        $('#GPProjectView').innerHeight(GP.project.sizeY * GPProjectView.sceneScale);
        $('.GPDesignPane').innerWidth(GP.project.sizeX * GPProjectView.sceneScale);
        $('.GPDesignPane').innerHeight(GP.project.sizeY * GPProjectView.sceneScale);

        GPProjectView.width = GP.project.sizeX * GPProjectView.sceneScale;
        GPProjectView.height = GP.project.sizeY * GPProjectView.sceneScale;

        GPProjectView.stage.width(GPProjectView.width);
        GPProjectView.stage.height(GPProjectView.height);

        if (GPProjectView.background) {
            GPProjectView.background.width(GPProjectView.width);
            GPProjectView.background.height(GPProjectView.height);
        }

        if (GPProjectView.reflection) {
            GPProjectView.backgroundLayer.setOffsetY(GPProjectView.height);
        }

        if (GPProjectView.texture) {
            GPProjectView.texture.width(GPProjectView.width);
            GPProjectView.texture.height(GPProjectView.height);
        }

        if (GPProjectView.cloner) {
            GPProjectView.cloner.width(GPProjectView.width);
            GPProjectView.cloner.height(GPProjectView.height);
        }

        GPContextTexture.onresize();
        GPContextItems.onresize();
        GPContextLabels.onresize();
        GPContextFixedCutter.onresize();
        GPContextInpainting.onresize();
        GPContextCloner.onresize();

        GPProjectView.positionHorizonHint();
    },

    getPointerPosition: function (event) {
        var pos = {};
        if (event.pageX) {
            pos.x = event.pageX - $('#GPProjectView').offset().left;
            pos.y = event.pageY - $('#GPProjectView').offset().top;
        } else {
            var touchPos = GPProjectView.stage.getPointerPosition();
            if (touchPos) {
                pos.x = touchPos.x;
                pos.y = touchPos.y;
            }
        }
        return pos;
    },


    positionHorizonHint: function () {
        var pos = GPProjectView.height * (1 - GP.project.horizonPos) + $("#GPProjectView").position().top;
        $('.GPHorizonHint').css("top", pos);        
    },
    
    
    showHorizonHint: function() {
        setTimeout(GPProjectView.hideHorizonHint, 2000);
        $('.GPHorizonHint').show();
    },
    
    hideHorizonHint: function() {
        $('.GPHorizonHint').hide();
    },


    /**
     * Set the cursor to the specified mode
     * @param {"movePlant"|"overPlant"|"addItem"|"standard"|"wait"|"textureBrush"|"fixedCutterBrush"|"inpaintingBrush"|"clonerBrush"} cursorMode
     */
    setCursor: function(cursorMode) {

        var cursorStyle = {
            "movePlant" : "pointer",
            "overPlant" : "pointer",
            "addItem" : "copy",
            "standard": "auto",
            "wait": "wait",
            "textureBrush": "pointer",
            "fixedCutterBrush" : "pointer",
            "inpaintingBrush" : "pointer",
            "clonerBrush" : "pointer"
        };

        if (GP.waitIndicator) cursorMode = "wait"; //wait has precedence
        if (!cursorMode && get(activePickerItem) && get(mode) === "Plants") cursorMode = "addItem";
        if (!cursorMode && get(activePickerItem) && get(mode) === "Structures") cursorMode = "addItem";
        if (!cursorMode && get(activePickerSnippet) && get(mode) === "Snippets") cursorMode = "addItem";
        if (!cursorMode && get(mode) === "Textures") cursorMode = "textureBrush";
        if (!cursorMode && get(mode) === "FixedCutter") cursorMode = "fixedCutterBrush";
        if (!cursorMode && get(mode) === "Inpainting") cursorMode = "inpaintingBrush";
        if (!cursorMode && get(mode) === "Cloner") cursorMode = "clonerBrush";
        if (!cursorMode) cursorMode="standard";

        $("body").css("cursor", cursorStyle[cursorMode]);

    },
    
    reflectView: function() {
        GPProjectView.reflection = true;
        GPProjectView.backgroundLayer.setScaleY(-1);
        GPProjectView.backgroundLayer.setOffsetY(GPProjectView.height);
        GPProjectView.textureLayer.visible(false);
        GPContextItems.repositionItems();
    },

    unreflectView: function() {
        GPProjectView.reflection = false;
        GPProjectView.backgroundLayer.setScaleY(1);
        GPProjectView.backgroundLayer.setOffsetY(0);
        GPProjectView.textureLayer.visible(true);
        GPContextItems.repositionItems();
    },

    snippetOnlyViewOn: function() {
        GP.project.items.forEach(item => {
            let viewEl = GPProjectView.getItemImgData(item);
            viewEl.visible(item instanceof GPPlant && get(selectedItemSet).indexOf(item) >= 0);
            if (item instanceof GPPlant) viewEl.shadowEnabled(false);
            viewEl.cache();
        });
    },

    snippetOnlyViewOff: function() {
        GP.project.items.forEach(item => {
            let viewEl = GPProjectView.getItemImgData(item);
            viewEl.visible(true);
            viewEl.cache();
        });
        GPContextItems.refreshItemHighlights(get(selectedItemSet));
    },

    updateLabelsVisibility: function(show) {
        GP.project.items.forEach(item => {
            if (item instanceof GPLabel) {
                let viewEl = GPProjectView.getItemImgData(item);
                if (viewEl) {
                    viewEl.visible(show);
                    viewEl.getText().visible(show);
                    viewEl.getTag().visible(show);
                }
            }
        });
    },

    handleKeyboard: function(e) {
        //First handle page up / page down. Active all the time. Bring focus to the project area.
        let nonvirtual;
        switch (e.which) {
            case 33: // page up
                nonvirtual = GP.project.items.filter(itemInstance => !itemInstance.fixedObject);
                if (!nonvirtual.length) break;
                if (get(selectedItemSet).length === 1) {
                    let ni = nonvirtual.indexOf(get(selectedItemSet)[0]) + 1;
                    if (ni >= nonvirtual.length) ni = 0;
                    selectedItemSet.set([nonvirtual[ni]]);
                }
                if (get(selectedItemSet).length === 0) selectedItemSet.set([nonvirtual[0]]);
                $('.GPProjectView').focus();
                e.preventDefault();
                break;

            case 34: // page down
                nonvirtual = GP.project.items.filter(itemInstance => !itemInstance.fixedObject);
                if (!nonvirtual.length) break;
                if (get(selectedItemSet).length === 1) {
                    let ni = nonvirtual.indexOf(get(selectedItemSet)[0]) - 1;
                    if (ni < 0) ni = nonvirtual.length - 1;
                    selectedItemSet.set([nonvirtual[ni]]);
                }
                if (get(selectedItemSet).length === 0) selectedItemSet.set([nonvirtual[0]]);
                $('.GPProjectView').focus();
                e.preventDefault();
                break;
        }

    },
};

